import { Button, Tag, Wordmark, ShellTopbar, ShellTopbarActions } from "@cntrl/ui";
import styles from "./AdminShell.module.scss";

export interface AdminShellProps {
  children: React.ReactNode;
  onLogout: () => void;
}

/**
 * The admin console's shell — a separate view that shares no screens with the band app (R8 of
 * .design-specs/admin-console.plan.md). No BandProvider, OrgProvider or realtime: the console acts as no tenant,
 * so nothing band-scoped can render here by accident. An admin account is dedicated and has no app to go back to,
 * so the only way out is Log out. Phase 1 is one dashboard, so the bar carries no nav yet —
 * it gains one when a second screen exists.
 */
export function AdminShell({ children, onLogout }: AdminShellProps) {
  return (
    <div className={styles.shell}>
      <ShellTopbar>
        <div className={styles.brand} aria-label="CNTRL admin">
          <Wordmark size={22} />
          <Tag tone="neutral" size="sm">
            Admin
          </Tag>
        </div>
        <ShellTopbarActions>
          <Button variant="ghost" size="sm" onClick={onLogout}>
            Log out
          </Button>
        </ShellTopbarActions>
      </ShellTopbar>
      <main className={styles.content}>{children}</main>
    </div>
  );
}
